import { useContext, useEffect, useState } from 'react';
import { AppContext, RootWrapperContainer } from '../../App';

import { Chart } from "react-google-charts";
import { Color, ColorSAP, FONT_FAMILY, Globe, Typography } from '../../ontego-ui';

import { PaddedContainer } from '../../App';

import Grid from '@mui/material/Grid2';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { getTicks, getUpperBoundValue } from "../../Utils/Utils";
import DebugLogDialog from './DebugLogDialog';

import { LOG_TYPES_ENUM } from '../../Constants/LogTypeEnum';
import SystemMessageDialog from '../../Dialogs/SystemDialog/SystemMessageDialog';
import DeviceLimit from '../../ReusableComponents/DeviceLimit/DeviceLimit';
import EmptyChartData from '../../ReusableComponents/EmptyChartData/EmptyChartData';
import { SystemMessage } from '../../ReusableComponents/SystemMessage/SystemMessage';
import TotalCost from '../../ReusableComponents/TotalCost/TotalCost';
import ManageGlobalDevice from './ManageGlobalDevice';
import DashboardService from './ManageMainDashboardService';

const CustomerCostAndLogin = (props) => {
    const { data, currency } = props;
    const { t } = useTranslation();
    const customerCostAndLogin = data;

    let noChart = true;
    let costMaxValue = 0;
    let loginMaxValue = 0;

    if (customerCostAndLogin) {
        customerCostAndLogin.forEach((row, index) => {
            if (index > 0) {
                if (row[2] !== 0)
                    noChart = false;
                if (row[1] > costMaxValue)
                    costMaxValue = row[1];
                if (row[2] > loginMaxValue)
                    loginMaxValue = row[2];
            } else {
                row[1] = t(row[1]);
                row[2] = t(row[2]);
            }
        })
    }

    const costUpperBound = getUpperBoundValue(costMaxValue);
    const loginUpperBound = getUpperBoundValue(loginMaxValue);

    return (
        <div style={{ paddingTop: 0 }}>
            <Chart
                chartType="ColumnChart"
                data={customerCostAndLogin}
                width="100%"
                chartHeight={"355px"}
                options={{
                    chartArea: {
                        left: '9%',
                        right: '4%',
                        top: 5,
                        bottom: 100,
                        width: "100%",
                        height: 300
                    },
                    backgroundColor: "transparent",
                    colors: [ColorSAP.primary[70], ColorSAP.primary[40]],
                    legend: { position: 'bottom' },
                    series: {
                        0: { axis: 'cost', targetAxisIndex: 0 },
                        1: { axis: 'login', targetAxisIndex: 1 }
                    },
                    vAxes: {
                        0: {
                            textStyle: {
                                fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM,
                                color: Color.neutral[400],
                            },
                            ticks: getTicks(costUpperBound),
                            viewWindow: {
                                min: 0,
                                max: costUpperBound
                            },
                            format: '#,##0.00 ' + currency
                        },
                        1: {
                            textStyle: {
                                fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM,
                                color: Color.neutral[400],
                            },
                            ticks: getTicks(loginUpperBound),
                            viewWindow: {
                                min: 0,
                                max: loginUpperBound
                            },
                        }
                    },
                    hAxis: {
                        textStyle: {
                            fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_MEDIUM,
                            color: Color.neutral[400],
                        }
                    },
                    bar: {
                        groupWidth: "40",
                        borderRadius: 4
                    },
                    tooltip: { isHtml: true, trigger: "visible" }
                }}
                chartEvents={[{
                    eventName: 'ready',
                    callback: (ce) => {
                        if (!ce?.chartWrapper?.getChart()) return;

                        const chart = ce.chartWrapper.getChart();
                        var defses = document.getElementsByTagName('defs');
                        var gradientInjectFound = false;
                        Array.prototype.forEach.call(defses, function (defs) {
                            if (defs.getAttribute('id') === 'gradientInject') {
                                gradientInjectFound = true;
                            }
                        });
                        if (!gradientInjectFound) {
                            Array.prototype.forEach.call(defses, function (defs) {
                                defs.insertAdjacentHTML('afterend', '<defs id="gradientInject"><linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#0077b6;stop-opacity:1" /><stop offset="100%" style="stop-color:#00527f;stop-opacity:1" /></linearGradient></defs>');
                            });
                        }
                        var rects = chart.container.getElementsByTagName('rect');
                        Array.prototype.forEach.call(rects, function (rect) {
                            if (rect.getAttribute('fill') === '#00527f') {
                                rect.setAttribute('fill', 'url(#grad1)');
                            }
                        });
                        ce.google.visualization.events.addListener(chart, "onmouseover", (e) => {
                            var rects = chart.container.getElementsByTagName('rect');
                            Array.prototype.forEach.call(rects, function (rect) {
                                if (rect.getAttribute('fill') === '#00527f') {
                                    rect.setAttribute('fill', 'url(#grad1)');
                                }
                            });
                        });
                        ce.google.visualization.events.addListener(chart, "onmouseout", (e) => {
                            var rects = chart.container.getElementsByTagName('rect');
                            Array.prototype.forEach.call(rects, function (rect) {
                                if (rect.getAttribute('fill') === '#00527f') {
                                    rect.setAttribute('fill', 'url(#grad1)');
                                }
                            });
                        });
                        ce.google.visualization.events.addListener(chart, "animationfinish", (e) => {
                            var rects = chart.container.getElementsByTagName('rect');
                            Array.prototype.forEach.call(rects, function (rect) {
                                if (rect.getAttribute('fill') === '#00527f') {
                                    rect.setAttribute('fill', 'url(#grad1)');
                                }
                            });
                        });
                    },
                },
                {
                    eventName: 'select',
                    callback: (ce) => {
                        const chart = ce.chartWrapper.getChart();
                        var rects = chart.container.getElementsByTagName('rect');
                        Array.prototype.forEach.call(rects, function (rect) {
                            if (rect.getAttribute('fill') === '#00527f') {
                                rect.setAttribute('fill', 'url(#grad1)');
                            }
                        });
                    },
                }]}
                loader={<div>Loading Chart</div>}
            />
            {noChart && (
                <EmptyChartData />
            )}
        </div>
    )
}

const ManageMainDashboard = () => {
    const { t } = useTranslation()

    const { userInfo, handleShowErrorSnackbar, client } = useContext(AppContext)
    const [debugLogDialogOpen, setDebugLogDialogOpen] = useState(false)

    const [cost, setCost] = useState(0);
    const [deviceCount, setDeviceCount] = useState(0);
    const [chart, setChart] = useState([]);
    const [logs, setLogs] = useState([]);
    const [systemMessageDialogOpen, setSystemMessageDialogOpen] = useState(false);
    const [isClientDataLoading, setIsClientDataLoading] = useState(false)

    const handleCloseDebugLogDialog = () => setDebugLogDialogOpen(false)

    useEffect(() => {
        window.scrollTo(0, 0)

        if (userInfo) {
            fetchClientData();
        }
    }, [])

    const fetchClientData = () => {
        setIsClientDataLoading(true)
        const logParam = { currentPage: 1, logLimit: 10, startDate: "", endDate: "", logType: "", search: "" }
        DashboardService.getClientsData(userInfo.key, logParam)
            .then(results => {
                const { chartData, logEntries } = results.data;

                logEntries.forEach(log => {
                    // TODO i18n dates
                    log.date = moment(log.timestamp).format('DD.MM.YYYY');
                    log.time = moment(log.timestamp).format('HH:mm:ss');
                    log.log_type = LOG_TYPES_ENUM[log.log_type];
                });
                
                setCost(chartData[chartData.length - 1][1]);
                setChart(chartData);
                setLogs(logEntries);
                setDeviceCount(chartData[chartData.length - 1][2]);
                setIsClientDataLoading(false)
            })
            .catch(error => handleShowErrorSnackbar(error));
    }

    const getDeviceLimitData = () => {
        return {
            key: client.key,
            activeDevice: deviceCount,
            deviceLimit: client.deviceLimit
        }
    }

    const handleSubmitDeviceLimit = (device) => {
        DashboardService.updateClientDeviceLimit(userInfo.key, device.deviceLimit)
            .then(() => { })
            .catch(error => handleShowErrorSnackbar(error));
    }

    const handleOpenSystemMessageDialog = () => {
        setSystemMessageDialogOpen(true);
    }

    const handleCloseSystemMessageDialog = () => {
        setSystemMessageDialogOpen(false);
    }

    return (
        <RootWrapperContainer>
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Grid container spacing={2}>
                        <Grid item size={12}>
                            <PaddedContainer>
                                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 64, marginTop: 32 }}>
                                    <Typography
                                        fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                                        size={28}
                                        color={ColorSAP.neutral[100]}
                                    >
                                        {t("manage.greetingWords")} {client.name}
                                    </Typography>
                                </div>
                                <Grid container spacing={2}>
                                    <Grid item size={{ md: 4 }}>
                                        <Grid item size={12}>
                                            <div
                                                style={{
                                                    position: "relative",
                                                    width: "100%",
                                                    height: 435
                                                }}
                                            >
                                                <TotalCost totalCost={{ price: cost, billedDate: moment().endOf("month").toDate(), currency: client.currency }} />
                                            </div>
                                        </Grid>
                                    </Grid>
                                    <Grid item size={{ md: 8 }}>
                                        <div
                                            style={{
                                                position: "relative",
                                                width: "100%",
                                                height: 435,
                                                backgroundColor: ColorSAP.neutral[15],
                                                boxSizing: "border-box",
                                                padding: "32px 40px 32px 40px",
                                                borderRadius: 18
                                            }}
                                        >
                                            {/** TITLE */}
                                            <Typography
                                                fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                                                size={24}
                                                color={ColorSAP.neutral[100]}
                                            >
                                                {t("manage.customerCostAndDevices")}
                                            </Typography>
                                            {/** TABS */}
                                            <div
                                                style={{
                                                    marginTop: 20
                                                }}
                                            >
                                                <CustomerCostAndLogin data={chart} currency={client.currency} />
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ md: 4 }}>
                                        <DeviceLimit
                                            data={getDeviceLimitData()}
                                            handleSubmitDeviceLimit={handleSubmitDeviceLimit}
                                        />
                                    </Grid>
                                    <Grid item size={{ md: 8 }}>
                                        <SystemMessage
                                            log={logs.slice(0, 20)}
                                            handleViewMore={handleOpenSystemMessageDialog}
                                            isLoading={isClientDataLoading}
                                        />
                                    </Grid>
                                </Grid>
                            </PaddedContainer>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item size={12}>
                    <div style={{ width: '100%', marginTop: 24, boxSizing: 'border-box', paddingTop: 40, paddingBottom: 90 }}>
                        <PaddedContainer>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Globe
                                    style={{
                                        width: 24,
                                        height: 24,
                                        color: ColorSAP.primary[70],
                                        marginRight: 10,
                                    }}
                                />
                                <Typography
                                    fontFamily={FONT_FAMILY.PLUS_JAKARTA_SANS_BOLD}
                                    size={16}
                                    color={ColorSAP.neutral[100]}
                                >
                                    {t("breadcrumb.appManagement")}
                                </Typography>
                            </div>
                        </PaddedContainer>

                        <ManageGlobalDevice />
                    </div>
                </Grid>
            </Grid>

            {debugLogDialogOpen && (
                <DebugLogDialog
                    open={debugLogDialogOpen}
                    handleClose={handleCloseDebugLogDialog}
                />
            )}

            <SystemMessageDialog
                open={systemMessageDialogOpen}
                onClose={handleCloseSystemMessageDialog}
                log={logs}
                setLogs={setLogs}
            />
        </RootWrapperContainer>
    )
}

export default ManageMainDashboard